import React from 'react';
import PropTypes from 'prop-types';

import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';

function ProductStatusSection({ title, dataCy, columns, rows, emptyText }) {
  return (
    <Paper sx={{ mb: 2 }}>
      <Typography variant="h6" sx={{ px: 2, pt: 2, pb: 1 }}>
        {title}
      </Typography>

      {rows.length === 0 ? (
        <Typography data-cy={`${dataCy}-empty`} sx={{ px: 2, pb: 2 }} color="text.secondary">
          {emptyText}
        </Typography>
      ) : (
        <TableContainer>
          <Table stickyHeader size="small" data-cy={dataCy}>
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell key={column.key}>{column.label}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, rowIndex) => (
                <TableRow key={`${row.PartNo || 'part'}-${rowIndex}`} hover>
                  {columns.map((column) => (
                    <TableCell key={column.key}>{row[column.key] ?? ''}</TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Paper>
  );
}

ProductStatusSection.propTypes = {
  title: PropTypes.string.isRequired,
  dataCy: PropTypes.string.isRequired,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  emptyText: PropTypes.string.isRequired,
};

export default React.memo(ProductStatusSection);
